import React from 'react';
import '../css/recaudacionHistorica.css'; // Crea este CSS o ponlo en App.css

const RecaudacionHistorica = () => {
  return (
    <div className="recaudacion-banner">
      <div className="recaudacion-content">
        <span className="recaudacion-label">RECAUDADO EN TODOS LOS RETOS</span>
        <div className="recaudacion-cifra">
          <span className="recaudacion-simbolo">+</span>
          <span className="recaudacion-numero">73.000</span>
          <span className="recaudacion-euro">€</span>
        </div>
        <div className="recaudacion-linea"></div>
        <p className="recaudacion-gracias">GRACIAS POR HACERLO POSIBLE</p>
      </div>
    </div>
  );
};

export default RecaudacionHistorica;